import { render } from "./MOptionButton.vue?vue&type=template&id=776f3fac"
import script from "./MOptionButton.vue?vue&type=script&lang=js"
export * from "./MOptionButton.vue?vue&type=script&lang=js"

import "./MOptionButton.vue?vue&type=style&index=0&id=776f3fac&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__